import { ServicesContainer } from '@/services';
import { LoginCompleteEvent } from '@/services/analytics/events/login-complete-event';
import { AnalyticsEventType } from '@/services/analytics/platforms/adobe-analytics/models';
import { AppState } from '@/store';
import { Store } from 'vuex';
import { AdobeBaseEvent } from './adobe-base-event';
import { AUTOMATIC_PERSONALIZATION_AGE } from '@/constants';
import { calculateAge } from '@/helpers/util';

export class AdobeLoginCompleteEvent extends AdobeBaseEvent {
  event = AnalyticsEventType.LoginComplete;

  constructor(event: LoginCompleteEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);

    const profile = store.state.customer.profile;
    const currentPointsBalance = services.loyalty.isEnrolledInLoyalty(profile) ? store.state.customer.rewardPoints?.currentPointsBalance : '0';

    this.account.userID = store.state.customer.profile?.customerIdHash;
    this.account.loginType = event.loginType;
    this.account.availablePoints = currentPointsBalance != undefined ? currentPointsBalance : 'fail';
    this.account.logins = { value: 1 };
    this.account.optOutPers = !store.state.customer.optedIntoPersonalizationMessaging;
    this.account.under18 = profile?.dateOfBirth && calculateAge(profile.dateOfBirth) < AUTOMATIC_PERSONALIZATION_AGE
  }
}